// PreAppHistoryReportPage.jsx
import React from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { useLazyExportPreAppHistoryToExcelQuery } from '../../../api/endpoints/preAppHistoryReport';
import PreAppHistoryReportTable from './component/PreAppHistoryReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import usePreAppHistoryReportData from './hook/usePreAppHistoryReportData';

const PreApprovalHistoryReportPage = () => {
    const { th } = useLanguage();
    const { apiData, isLoading, lazyParams, sortField, sortOrder, activeFilters, onPage, onSort, handleFilterChange, initFilters, exportParams } = usePreAppHistoryReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('preApprovalHistoryReport.title')}</h1>{' '}
                <div className="flex gap-2">
                    {' '}
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportPreAppHistoryToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'on_onay_gecmisi.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>
            <PreAppHistoryReportTable
                items={apiData?.items ?? []}
                totalCount={apiData?.totalCount ?? 0}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default PreApprovalHistoryReportPage;
